import camelCase from 'lodash/camelCase'
import upperFirst from 'lodash/upperFirst'
export const isFunction = (obj) => typeof obj === 'function'

export const uniqueId = (() => {
    let idCounter = 0
    return (prefix) => {
        idCounter++
        return `${prefix}_${idCounter}`
    }
})()

export const toCssModifier = (value, capitalizeFirstLetter = true) => {
    return (capitalizeFirstLetter ? upperFirst(camelCase(value)) : camelCase())
}



// WEBPACK FOOTER //
// ../node_modules/react-wot-bootstrap/lib/helpers/utils.js